import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'
import concat from 'lodash/concat'

export default RouteGroup({

  prefix: '/user',

  routes: concat(
    [
      Route('/admins', 'user.admins', view('user/Admins')),
      Route('/admin', 'user.newAdmin', view('user/NewAdmin')),
      Route('/admin/:user/edit', 'user.editAdmin', view('user/EditAdmin')),
      Route('/tenants', 'user.tenants', view('user/Tenants')),
      Route('/tenant', 'user.newTenant', view('user/NewTenant')),
      Route('/customers', 'user.customers', view('user/Customers')),
      Route('/signins', 'user.signins', view('user/SignIns')),
    ],

    RouteGroup({
      parent: Route('/:user', '', view('user/Manager')),
      routes: [
        Route('/', 'user.manager', view('user/manager/Account')),
        Route('bookings', 'user.bookings', view('user/manager/Bookings')),
        Route('edit', 'user.edit', view('user/manager/Edit')),
        Route('documents', 'user.documents', view('user/manager/Documents')),
        Route('deposits', 'user.deposits', view('user/manager/Deposits'))
      ]
    })
  )
})